import { render, staticRenderFns } from "./businessZS.vue?vue&type=template&id=d892c8bc&scoped=true"
import script from "./businessZS.vue?vue&type=script&lang=ts"
export * from "./businessZS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d892c8bc",
  null
  
)

export default component.exports